// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publish-modal .modal-container {
  width: 460px !important;
  height: 720px !important;
}
.publish-modal .modal-container .modal-content {
  overflow: auto;
}

.vendor-modal .modal-container {
  width: 75% !important;
  height: 85% !important;
  position: relative !important;
  padding: 32px 48px 24px 48px !important;
}
.vendor-modal .modal-container .modal-content {
  overflow: auto;
}

.success-modal .modal-container {
  width: 520px !important;
  height: 430px !important;
}
.success-modal .modal-container .modal-content {
  overflow: auto;
}
.success-modal .modal-container .modal-header {
  padding-top: 0 !important;
}

.aadhar-modal .modal-container {
  width: 480px !important;
  height: 582px !important;
}
.aadhar-modal .modal-container .modal-content {
  overflow: auto;
  padding-top: 0 !important;
}
.aadhar-modal .modal-header button {
  width: -moz-fit-content !important;
  width: fit-content !important;
}

.gst-upload-modal .modal-container .modal-content {
  overflow: auto;
}

.w-700 {
  width: 700px !important;
}

.vendor-btn {
  width: 240px;
  height: 56px;
}

/* Verification form specific tweaks for mobile */
.verification-form {
  max-width: 720px;
  margin: 0 auto;
}
.verification-form .verify-check {
  position: absolute;
  right: 16px;
  top: 50%;
  z-index: 10;
}

@media (max-width: 768px) {
  .verification-form {
    padding-left: 16px !important;
    padding-right: 16px !important;
    /* ensure dropdowns and inputs take full width and consistent height */
    /* keep GSTIN state-code prefix vertically centered on mobile */
  }
  .verification-form .verify-check {
    right: 12px;
    top: 50%;
  }
  .verification-form input, .verification-form .dropdown-selector, .verification-form .verification-form input {
    height: 44px !important;
  }
  .verification-form .input-content-left {
    height: 44px !important;
  }
  .verification-form .input-content-left .content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .verification-form .label-14 {
    font-size: 14px !important;
  }
  .vendor-modal .modal-container {
    width: 95% !important;
    padding: 12px 14px !important;
  }
  .vendor-modal .vendor-modal-body {
    flex-direction: column !important;
    gap: 12px !important;
  }
  .vendor-modal .vendor-modal-content-wrapper {
    min-height: 0;
  }
  .success-modal .modal-container {
    width: 95% !important;
    height: auto !important;
    max-height: calc(100dvh - 40px) !important;
    padding: 0 !important;
  }
  .success-modal .modal-header {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
    border: 0 !important;
  }
  .success-modal .modal-content {
    max-height: calc(100dvh - 40px) !important;
    overflow-y: auto !important;
    padding: 12px !important;
  }
  .success-modal .modal-content > div {
    padding: 12px !important;
    padding-bottom: 20px !important;
    gap: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/event-create/components/step-4/style.scss"],"names":[],"mappings":"AACI;EACC,uBAAA;EACA,wBAAA;AAAL;AACK;EACG,cAAA;AACR;;AAII;EACI,qBAAA;EACA,sBAAA;EACA,6BAAA;EACA,uCAAA;AADR;AAEQ;EACI,cAAA;AAAZ;;AAMI;EACI,uBAAA;EACA,wBAAA;AAHR;AAIQ;EACI,cAAA;AAFZ;AAII;EACI,yBAAA;AAFR;;AAOI;EACI,uBAAA;EACA,wBAAA;AAJR;AAKQ;EACI,cAAA;EACA,yBAAA;AAHZ;AAOQ;EACI,kCAAA;EAAA,6BAAA;AALZ;;AAWQ;EACI,cAAA;AARZ;;AAYA;EACI,uBAAA;AATJ;;AAYA;EACI,YAAA;EACA,YAAA;AATJ;;AAYA,iDAAA;AACA;EACI,gBAAA;EACA,cAAA;AATJ;AAWI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;AATR;;AAeA;EACI;IACI,6BAAA;IACA,8BAAA;IAOA,sEAAA;IAKA,+DAAA;EAtBN;EAYM;IACI,WAAA;IACA,QAAA;EAVV;EAcM;IACI,uBAAA;EAZV;EAgBM;IACI,uBAAA;EAdV;EAiBM;IACI,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,yBAAA;IACA,4BAAA;EAfV;EAkBM;IAAY,0BAAA;EAflB;EAmBM;IACI,qBAAA;IACA,6BAAA;EAjBV;EAoBM;IACI,iCAAA;IACA,oBAAA;EAlBV;EAqBM;IACI,aAAA;EAnBV;EAwBM;IACI,qBAAA;IACA,uBAAA;IACA,0CAAA;IACA,qBAAA;EAtBV;EAyBM;IACI,wBAAA;IACA,oBAAA;IACA,wBAAA;IACA,qBAAA;IACA,oBAAA;EAvBV;EA0BM;IACI,0CAAA;IACA,2BAAA;IACA,wBAAA;EAxBV;EA2BM;IACI,wBAAA;IACA,+BAAA;IACA,oBAAA;EAzBV;AACF","sourcesContent":[".publish-modal {\n    .modal-container {\n     width: 460px !important;\n     height: 720px !important;\n     .modal-content {\n        overflow: auto;\n      }\n     }\n}\n.vendor-modal {\n    .modal-container {\n        width: 75% !important;\n        height: 85% !important;\n        position:  relative !important;\n        padding: 32px 48px 24px 48px !important;\n        .modal-content {\n            overflow: auto;\n        }\n    }\n\n}\n.success-modal{\n    .modal-container{\n        width: 520px !important;\n        height: 430px !important;\n        .modal-content {\n            overflow: auto;\n          }\n    .modal-header{\n        padding-top:0 !important;\n    }\n    }\n}\n.aadhar-modal{\n    .modal-container{\n        width: 480px !important;\n        height: 582px !important;\n        .modal-content {\n            overflow: auto;\n            padding-top: 0 !important;\n          }\n    }\n    .modal-header{\n        button{\n            width: fit-content !important;\n        }\n    }\n}\n.gst-upload-modal{\n    .modal-container{\n        .modal-content {\n            overflow: auto;\n          }\n    }\n}\n.w-700{\n    width: 700px !important;\n}\n\n.vendor-btn{\n    width: 240px;\n    height: 56px;\n}\n\n/* Verification form specific tweaks for mobile */\n.verification-form {\n    max-width: 720px;\n    margin: 0 auto;\n\n    .verify-check {\n        position: absolute;\n        right: 16px;\n        top: 50%;\n        z-index: 10;\n    }\n\n  \n}\n\n@media (max-width: 768px) {\n    .verification-form {\n        padding-left: 16px !important;\n        padding-right: 16px !important;\n\n        .verify-check {\n            right: 12px;\n            top: 50%;\n        }\n\n        /* ensure dropdowns and inputs take full width and consistent height */\n        input, .dropdown-selector, .verification-form input {\n            height: 44px !important;\n        }\n\n        /* keep GSTIN state-code prefix vertically centered on mobile */\n        .input-content-left {\n            height: 44px !important;\n        }\n\n        .input-content-left .content {\n            height: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding-top: 0 !important;\n            padding-bottom: 0 !important;\n        }\n\n        .label-14 { font-size: 14px !important; }\n    }\n\n    .vendor-modal {\n        .modal-container {\n            width: 95% !important;\n            padding: 12px 14px !important;\n        }\n\n        .vendor-modal-body {\n            flex-direction: column !important;\n            gap: 12px !important;\n        }\n\n        .vendor-modal-content-wrapper {\n            min-height: 0;\n        }\n    }\n\n    .success-modal {\n        .modal-container {\n            width: 95% !important;\n            height: auto !important;\n            max-height: calc(100dvh - 40px) !important;\n            padding: 0 !important;\n        }\n\n        .modal-header {\n            display: none !important;\n            height: 0 !important;\n            min-height: 0 !important;\n            padding: 0 !important;\n            border: 0 !important;\n        }\n\n        .modal-content {\n            max-height: calc(100dvh - 40px) !important;\n            overflow-y: auto !important;\n            padding: 12px !important;\n        }\n\n        .modal-content > div {\n            padding: 12px !important;\n            padding-bottom: 20px !important;\n            gap: 20px !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
